import {
  experimental_extendTheme as materialExtendTheme,
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from "@mui/material/styles";
import { extendTheme } from "@mui/joy";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { acquireToken } from "../../../authentication/utils/authUtils";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
const materialTheme = materialExtendTheme();
import * as React from "react";
import { useState } from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { formatTodaysDate } from "../../../utils/dateUtils";
export default function StudentCard({ student, attendance }) {
  const baseTheme = extendTheme();
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const [attendanceTakenToday, setAttendanceTakenToday] = useState(false);

  const darkOnlyTheme = extendTheme({
    cssVarPrefix: "sidebar_",
    colorSchemes: {
      light: baseTheme.colorSchemes.dark,
      dark: baseTheme.colorSchemes.dark,
    },
  });
  const todayDate = new Date().toLocaleDateString("en-US");
  React.useEffect(() => {
    if (attendance.length > 0) {
      const lastAttendanceDate = new Date(
        attendance[0]?.cr855_date
      ).toLocaleDateString("en-US", { timeZone: "UTC" });

      setAttendanceTakenToday(lastAttendanceDate === todayDate);
    }
  }, [attendance, todayDate]);
  const handleAttendanceButton = async () => {
    let today = formatTodaysDate();
    let token = await acquireToken(instance, account);
    let data = {
      cr855_date: today,
      "cr855_contact@odata.bind": `/contacts(${student.contactid})`,
    };

    try {
      await axios.post("/api/takeAttendance", data, {
        headers: { Authorization: token.accessToken },
      });
    } catch (error) {
      console.error("Error taking attendance", error);
    } finally {
      setAttendanceTakenToday(true);
      attendance.unshift(data);
    }
  };

  return (
    <MaterialCssVarsProvider theme={darkOnlyTheme}>
      <JoyCssVarsProvider>
        <CssBaseline enableColorScheme />
        <Box
          sx={{
            width: { xs: "100%", sm: "50%" },
            position: "relative",
            overflow: { xs: "auto", sm: "initial" },
            paddingTop: 1,
            paddingRight: 1,
          }}
        >
          <Card
            orientation="horizontal"
            sx={{
              borderColor: "rgba(48, 49, 48, 0.78)",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              // make the card resizable for demo
            }}
          >
            {student.entityimage && (
              <AspectRatio
                ratio="1"
                sx={{
                  minWidth: 182,
                  maxHeight: { xs: 364, sm: 182 },
                }}
              >
                <img
                  src={`data:image/png;base64, ${student.entityimage}`}
                  alt={student.fullname ? student.fullname.charAt(0) : ""}
                />
              </AspectRatio>
            )}
            <CardContent>
              <Typography
                sx={{ fontSize: "xl", fontWeight: "lg" }}
                textColor="rgba(255, 255, 255, 0.89)"
              >
                {student.fullname}
              </Typography>
              <Typography
                level="body-sm"
                textColor="rgba(229, 234, 238, 0.75)"
                sx={{ fontWeight: "lg" }}
              >
                Coder Athlete
              </Typography>
              <Sheet
                sx={{
                  bgcolor: "rgba(55, 59, 63, 0.3)",
                  borderRadius: "sm",
                  p: 1.5,
                  my: 1.5,
                  display: "flex",
                  gap: 2,
                  "& > div": { flex: 1 },
                }}
              >
                <div>
                  <Typography
                    level="body-xs"
                    sx={{ fontWeight: "lg" }}
                    textColor="rgb(161, 172, 183)"
                  >
                    Classes Attended
                  </Typography>
                  <Typography textColor="white" sx={{ fontWeight: "lg" }}>
                    {attendance.length}
                  </Typography>
                </div>

                <div>
                  <Typography
                    level="body-xs"
                    sx={{ fontWeight: "lg" }}
                    textColor="rgb(161, 172, 183)"
                  >
                    Last Attended
                  </Typography>
                  <Typography
                    noWrap
                    textColor="white"
                    sx={{ fontWeight: "lg" }}
                  >
                    {attendance[0]?.cr855_date
                      ? new Date(attendance[0].cr855_date).toLocaleDateString(
                          "en-US",
                          { timeZone: "UTC" }
                        )
                      : "None in Specified Range"}
                  </Typography>
                </div>
              </Sheet>
              <Box
                sx={{ display: "flex", gap: 1.5, "& > button": { flex: 1 } }}
              >
                <Button
                  sx={{ color: "white", borderColor: "rgba(48, 49, 48, 0.78)" }}
                  variant="solid"
                  color="primary"
                  onClick={handleAttendanceButton}
                  disabled={attendanceTakenToday}
                >
                  {attendanceTakenToday
                    ? "Attendance Taken Today"
                    : "Take Attendance"}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </JoyCssVarsProvider>
    </MaterialCssVarsProvider>
  );
}
